<template>
    <div class="footer wow fadeInUp">
        <div class="rowFluid">
            <div class="span12">
            <div class="container">
                <div class="footer_content">
                <div class="span4 col-xm-12">
                    <div class="footer_list">
                    <div class="span6">
                        <div class="bottom_logo"> </div>
                    </div>
                    <div class="span6 col-xm-12">
                        <div class="quick_navigation">
                        <div class="quick_navigation_title">快速导航</div>
                        <ul>
                            <li> <a href="/" title="首页">首页</a> </li>
                            <!-- <li> <a href="/a/jiejuefangan/" title="解决方案">解决方案</a> </li> -->
                            <li> <a href="/#/contactUs" title="关于我们">关于我们</a> </li>
                            <li> <a href="/#/contactUs" title="联系我们">联系我们</a> </li>
                        </ul>
                        </div>
                    </div>
                    </div>
                </div>
                <div class="span4 col-xm-6 col-xs-12">
                    <div class="footer_list">
                    <div class="footer_link">
                        <div class="footer_link_title">友情链接</div>
                        <ul id="frientLinks">
                            <li><a href='http://www.okjiuye.com' target='_blank'>实习就业平台</a> </li>
                        </ul>
                    </div>
                    </div>
                </div>
                <div class="span4 col-xm-6 col-xs-12">
                    <div class="footer_list">
                    <div class="footer_cotact">
                        <div class="footer_cotact_title">联系方式</div>
                        <ul>
                        <li><span class="footer_cotact_type">地址：</span><span class="footer_cotact_content">唐山市高新技术开发区富华东里惠安楼7楼3门501号</span></li>
                        <li><span class="footer_cotact_type">电话：</span><span class="footer_cotact_content"><a href="" class="call">0315-899lll2</a></span></li>
                        <li><span class="footer_cotact_type">网址：</span><span class="footer_cotact_content"><a href="#" title="官网">www.okjiuye.com</a></span></li>
                        <li><span class="footer_cotact_type">邮箱：</span><span class="footer_cotact_content">wizhikj#sina.com</span></li>
                        </ul>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <div class="copyright">Copyright &copy; 2023-2025  版权所有 冀ICP备2026020776号-2</div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    data() {
        return {
            
        }
    }
}
</script>
<style lang="less" rel="stylesheet/less" scoped>
    
</style>


// WEBPACK FOOTER //
// src/components/footerBar/footerBar.vue